import {GET, GETP, _t, logError} from "../function.js";

/**
 * Модель авторизованного пользователя
 */
export const users = new jqueryts.DataCollection({
    url: function (){
        return GETP("auth").then(res=>{
            try {
                if (res.hasOwnProperty("code")){
                    return []
                }
                return [res]
            } catch (e) {
                logError(e)
            }
        })
    }
});

/**
 * Модель списка категорий пользователя
 */
export const user_category = new jqueryts.DataCollection({
    url: function (){
        return GETP("auth/cat_user").then(res=>{
            try {
                res=res.map(el=>{
                    el.id=el.id_category
                    el.name=_t(el.name)
                    return el
                })
                return res
            } catch (e) {
                logError(e)
            }
        })
    }
});

/**
 * Модель статистики количества ошибок для администратора
 */
export const error_count = window.err_count


